import { gql } from "@apollo/client";

export const CREATE_OPERATOR_ACCOUNT_ROLE = gql`
  mutation ($accessPermissions: String!, $operatorId: ID!, $roleName: String!) {
    createOperatorAccountRole(
      accessPermissions: $accessPermissions
      operatorId: $operatorId
      roleName: $roleName
    ) {
      operatorAccountRole {
        operatorAccountRoleId
      }
    }
  }
`;

export const UPDATE_OPERATOR_ACCOUNT_ROLE = gql`
  mutation ($input: OperatorAccountRoleInput!) {
    updateOperatorAccountRole(input: $input) {
      operatorAccountRole {
        operatorAccountRoleId
      }
    }
  }
`;

export const ALL_OPERATOR_ACCOUNT_ROLES = gql`
  query ($operatorId: ID!) {
    allOperatorAccountRoles(operatorId: $operatorId) {
      operatorAccountRoleId
      roleName
      accessPermissions
      createdAt
      updatedAt
    }
  }
`;

export const OPERATOR_ACCOUNT_ROLE_BY_ID = gql`
  query ($operatorAccountRoleId: ID!) {
    operatorAccountRoleById(operatorAccountRoleId: $operatorAccountRoleId) {
      operatorAccountRoleId
      roleName
      accessPermissions
    }
  }
`;

export const UPDATE_MULTIPLE_OPERATOR_ACCOUNT_ROLE = gql`
  mutation (
    $operatorId: ID!
    $operatorAccountRoleId: ID!
    $accessPermissions: String!
  ) {
    updateMultipleOperatorAccountMutation(
      operatorId: $operatorId
      operatorAccountRoleId: $operatorAccountRoleId
      accessPermissions: $accessPermissions
    ) {
      userAccessPermission {
        operatorAccountId
      }
    }
  }
`;

export const GET_ACCOUNT_ACCESS_PERMISSIONS = gql`
  query ($operatorId: ID, $operatorAccountId: ID) {
    findOperatorAccountById(
      operatorId: $operatorId
      operatorAccountId: $operatorAccountId
    ) {
      username
      operator {
        operatorId
        company
      }
      active
      adminAccess
      accessPermissions
      userEmail
      operatorAccountRoleId
    }
  }
`;
